import { StateModel } from 'src/shared/models';
import {
  GET_IMPORT_CONFIGURATIONS,
  GET_IMPORT_CONFIGURATIONS_ERROR,
  GET_IMPORT_CONFIGURATIONS_SUCCESS,
  DELETE_IMPORT_CONFIGURATION,
  DELETE_IMPORT_CONFIGURATION_SUCCESS,
  DELETE_IMPORT_CONFIGURATION_ERROR,
} from '../actions/import-configuration.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const importConfigurationReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_IMPORT_CONFIGURATIONS:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_IMPORT_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case GET_IMPORT_CONFIGURATIONS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };
    case DELETE_IMPORT_CONFIGURATION:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case DELETE_IMPORT_CONFIGURATION_SUCCESS:
      const content = state.data.content.filter(
        ({ id }: any) => id !== payload.importConfigurationId,
      );
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          content,
        },
      };
    case DELETE_IMPORT_CONFIGURATION_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        error,
      };

    default:
      return state;
  }
};
